import { z } from 'zod'

import { Food } from '@/modules/food/domain/models/Food'

import {
  CreateFoodStockFoodItemDTO,
  FoodStockFoodItem
} from './FoodStockFoodItem'

export const FoodStockFood = z.object({
  id: z.string(),
  food: Food,
  minimumQuantity: z.number(),
  items: FoodStockFoodItem.array()
})
export type FoodStockFood = z.infer<typeof FoodStockFood>

export const FoodStockFoodList = FoodStockFood.array()
export type FoodStockFoodList = z.infer<typeof FoodStockFoodList>

export const CreateFoodStockFoodDTO = z.object({
  foodId: z.string(),
  placeId: z.string(),
  patientId: z.string(),
  minimumQuantity: z.number(),
  items: CreateFoodStockFoodItemDTO.array().optional()
})
export type CreateFoodStockFoodDTO = z.infer<typeof CreateFoodStockFoodDTO>

export const CreateFoodStockFoodListDTO = z.object({
  foodId: z.string(),
  placeId: z.string(),
  patientId: z.string(),
  minimumQuantity: z.number(),
  items: CreateFoodStockFoodItemDTO.array().optional()
})
export type CreateFoodStockFoodListDTO = z.infer<
  typeof CreateFoodStockFoodListDTO
>

export const RelativeQuantity = z.enum(['SUFFICIENT', 'BELOW', 'ABOVE'])
export type RelativeQuantity = z.infer<typeof RelativeQuantity>

export const RelativeQuantityFilter = z.enum(['SUFFICIENT', 'BELOW', 'ALL'])
export type RelativeQuantityFilter = z.infer<typeof RelativeQuantityFilter>
